import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchProducts(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/products', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchProduct(ctx, { id }) {
            return new  Promise((resolve, reject) => {
                axios
                    .get(`/products/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        createProduct(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/products/create')
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addProduct(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/products', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteProduct(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/products/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateProduct(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/products/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },
        downloadProducts(ctx, data)  {
            return new Promise((resolve, reject) => 
            {
              axios
                  .post('/download-products',  data,{ responseType: 'arraybuffer' })
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }

    }
}